module.exports = __webpack_public_path__ + "assets/img/bdaa5959158166c0b120a82d86580e65.png";